module.exports = __webpack_public_path__ + "static/img/preview-05.59d17aca.webp";